import { smartCatalog } from '@/API'

export default {
  namespaced: true,
  state: {
    leads: [],
    allLeads: [],
    options: [],
    page: 1,
    isLoadLeads: false,
    qs: '',
    isAll: false,
  },
  getters: {
    getLeads(state) {
      return state.leads
    },
    getAllLeads(state) {
      return state.allLeads
    },
    getOptions(state) {
      return state.options
    },
    isLoadLeads(state) {
      return state.isLoadLeads
    },
    page(state) {
      return state.page
    },
    qs(state) {
      return state.qs
    },
    isAll(state) {
      return state.isAll
    },
  },
  mutations: {
    SET_LEADS(state, payload) {
      state.leads = payload
    },
    SET_QS(state, qs) {
      state.qs = qs
    },
    SET_IS_ALL(state, isAll) {
      state.isAll = isAll
    },
    SET_ALL_LEADS(state, payload) {
      state.allLeads = payload
    },
    ADD_LEADS(state, payload) {
      state.leads = [...state.leads, ...payload]
    },
    LOAD_LEADS(state, payload) {
      state.isLoadLeads = payload
    },
    INCREMENT_PAGE(state) {
      state.page += 1
    },
    REFRESH_PAGE(state) {
      state.page = 1
    }
  },
  actions: {
    async loadLeads({ commit, getters }, { domain, qs, _id }) {
      try {
        if ((qs || '') === getters.qs && getters.isAll) return
        commit('SET_QS', qs || '')
        commit('LOAD_LEADS', true)
        const { leads } = await smartCatalog.getLeads({ _id, domain, page: getters.page, qs })
        if (leads?.length) {
          commit('SET_IS_ALL', false)
          if (getters.page > 1) {
            commit('ADD_LEADS', leads)
          } else {
            commit('SET_LEADS', leads)
          }
          commit('INCREMENT_PAGE')
        } else {
          commit('SET_IS_ALL', true)
        }
        commit('LOAD_LEADS', false)
      } catch (error) {
        commit('LOAD_LEADS', false)
        console.error(error)
        console.error(error.response)
      }
    },
    async searchLeads({ commit }, { domain, qs, _id }) {
      try {
        commit('REFRESH_PAGE')
        const { leads } = await smartCatalog.getLeads({ domain, page: 1, qs, _id })
        commit('SET_LEADS', leads)
        if (leads?.length) {
          commit('INCREMENT_PAGE')
        }
      } catch (error) {
        console.error(error)
        console.error(error.response)
      }
    },
    async loadAllLeads({ commit }, { domain, _id }) {
      let page = 1
      let allLeads = []
      let tmpLeads = []
      do {
        const { leads } = await smartCatalog.getLeads({ _id, domain, page })
        tmpLeads = leads
        allLeads = [...allLeads, ...tmpLeads]
        page += 1
      } while (tmpLeads.length)

      commit('SET_ALL_LEADS', allLeads)
    }
  }
}
